import { FC, memo, useCallback } from 'react'
import { Button } from '@cargomart/ui'
import { CONSEST_DATA_PERSONAL_ACCOUNT_DOC, PRIVACY_POLICY_PERSONAL_DATA_DOC } from 'constants/docs'
import { FieldFormItem } from 'forms/FieldFormItem'
import FieldMobilePhone from 'forms/FieldMobilePhone'
import { Form } from 'forms/Form'
import { compose, phoneMobileNumberValid, required } from 'forms/validators'
import { AuthInitRequest } from 'schema'
import { Link } from 'src/tailwind-components/Link'

import { LoginFormProps } from './types'

const LoginForm: FC<LoginFormProps> = (props) => {
  const { onSubmit, isLoading } = props
  const title = 'Вход в личный кабинет'

  const initialValues = {
    username: undefined
  }

  const handleSubmit = useCallback(({ username }: AuthInitRequest) => onSubmit({ username }), [onSubmit])

  return (
    <>
      <div className="mb-6 mt-16 text-body-lg">{title}</div>
      <Form
        keepDirtyOnReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
        render={(formProps) => (
          <form
            className="flex w-full flex-col rounded-xl bg-surface px-8 pb-6 pt-8 md:w-[344px]"
            data-test-id="login--form"
            onSubmit={formProps.handleSubmit}
          >
            <FieldFormItem name="username">
              <FieldMobilePhone
                name="username"
                placeholder="Мобильный телефон"
                size="lg"
                testId="sign-in-phone"
                validate={compose(required, phoneMobileNumberValid)}
              />
            </FieldFormItem>

            <div>
              Продолжая, вы подтверждаете, что ознакомлены и согласны на{' '}
              <Link className="!bg-none !text-on-surface-link" target="_blank" to={CONSEST_DATA_PERSONAL_ACCOUNT_DOC}>
                обработку персональных данных в личном кабинете
              </Link>{' '}
              и с{' '}
              <Link className="!bg-none !text-on-surface-link" target="_blank" to={PRIVACY_POLICY_PERSONAL_DATA_DOC}>
                Политикой конфиденциальности персональных данных
              </Link>
            </div>

            <Button
              className="mt-6"
              data-test-id="sign-in-submit-btn"
              loading={isLoading}
              size="lg"
              type="submit"
              variant="solid"
            >
              Войти / Создать KDV ID
            </Button>
          </form>
        )}
      />
    </>
  )
}

export default memo(LoginForm)
